var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYouTube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5991 14.4495V9.54883L14.7993 11.9993L10.5991 14.4495Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37256 18.6274 0 12 0C5.37256 0 0 5.37256 0 12C0 18.6274 5.37256 24 12 24ZM14.4741 6.4502C13.48 6.41016 12.5444 6.40112 12.1704 6.39917H11.8281C11.0366 6.40356 7.72754 6.43921 6.67529 6.73218C6.01611 6.91528 5.49658 7.45752 5.31836 8.14746C5.03857 9.23901 5.00342 11.3694 4.99902 11.8848V12.1135C5.00342 12.6292 5.03857 14.7595 5.31836 15.8511C5.49414 16.5383 6.01367 17.0806 6.67529 17.2664C7.72754 17.5591 11.0366 17.595 11.8281 17.5994L11.9917 17.5999H12.0063L12.1704 17.5994C12.5444 17.5972 13.48 17.5881 14.4741 17.5483L14.8262 17.533C15.8271 17.4856 16.8271 17.4045 17.3232 17.2664C17.9819 17.083 18.502 16.5408 18.6802 15.8511C18.96 14.7595 18.9951 12.6292 18.9995 12.1135L19 12.0068V11.9917L18.9995 11.8848C18.9951 11.3694 18.96 9.23901 18.6802 8.14746C18.5044 7.46021 17.9844 6.91797 17.3232 6.73218C16.8271 6.59375 15.8271 6.51294 14.8262 6.46533L14.4741 6.4502Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.a49fede3264cf046e5c7de0f7aaa77dc.svg";
export { ForwardRef as ReactComponent };